import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=ce9a3c20&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=js&"
export * from "./newsList.vue?vue&type=script&lang=js&"
import style0 from "./newsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./newsList.vue?vue&type=style&index=1&id=ce9a3c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9a3c20",
  null
  
)

export default component.exports